export default {
  commonSearch: null,
  status: '',
};

export const config = {
  defaultSearchPropName: 'menuItemId',
  exceptionFilters: ['status'],
};
